module.exports = __webpack_public_path__ + "static/img/pro1-3.34bc5c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/eng/pro1-3.png
// module id = SBPU
// module chunks = 0